export default "__VITE_PUBLIC_ASSET__9f00ea4a__"